<template>
  <div class="buttonNavi">
    <b-button
      label="内部ユーザー検索"
      @click="getLinkTarget('InternalUserSearch','/philips/master/user/InternalUserSearch')"
      :class='getClass("InternalUserSearch")'
    />
    <b-button
      label="外部ユーザー検索"
      @click="getLinkTarget('ExternalUserSearch','/philips/master/user/ExternalUserSearch')"
      :class='getClass("ExternalUserSearch")'
    />
  </div>
</template>

<script>
export default {
  name: "UserNavi",
  props: ["pageid"],
  methods: {
    getLinkTarget: function(tabkind, target) {
      if (tabkind != this.pageid) {
        this.$router.push(target);
      }
    },
    getClass: function(tabkind) {
      var ret = "";
      if (tabkind == this.pageid) {
        ret += "active";
      } else {
        ret += "deactive";
      }
      return ret;
    }
  },
  data() {
    return {};
  },
  filters: {},
  components: {}
};
</script>
<style lang="scss" scoped>
.buttonNavi {
  margin-top: 10px;
  text-align: left;
}
// .tabLabel {
//   float: left;
//   text-align: center;
//   border-radius: 10px 10px 0px 0px;
//   border-width: 1px;
//   border-top-style: solid;
//   border-right-style: solid;
//   border-left-style: solid;
//   width: 150px;
//   height: 30px;
// }
.buttonNavi.active {
  color: white;
  border-color: #000894;
  background-color: #000894;
}
.buttonNavi.deactive {
  border-color: #f7f7f7;
  background-color: #e4e4e4;
}
button.button.active {
  color: white;
  border-color: #000894;
  background-color: #000894;
}
button.button.deactive {
  border-color: #f7f7f7;
  background-color: #e4e4e4;
}
.tab-content {
  width: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/master/user/UserNavi.vue